import { render, staticRenderFns } from "./BônusMensal.vue?vue&type=template&id=3f45b6f3&scoped=true"
import script from "./BônusMensal.vue?vue&type=script&lang=js"
export * from "./BônusMensal.vue?vue&type=script&lang=js"
import style0 from "./BônusMensal.vue?vue&type=style&index=0&id=3f45b6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45b6f3",
  null
  
)

export default component.exports